module.exports = __webpack_public_path__ + "img/26.95dd89c6.png";